import useWidth from '../../../../../../../../../components/Hooks/useWidth';
import PacksMenuHeaderDesktop from './components/PacksMenuHeaderDesktop';
import PacksMenuHeaderMobile from './components/PacksMenuHeaderMobile';

interface PacksMenuHeaderProps {
  readMode: boolean;
  onSearch: (query: string) => void;
}

const PacksMenuHeader = ({ readMode, onSearch }: PacksMenuHeaderProps) => {
  const { mobileWidth } = useWidth();

  return mobileWidth ? (
    <PacksMenuHeaderMobile readMode={readMode} onSearch={onSearch} />
  ) : (
    <PacksMenuHeaderDesktop readMode={readMode} onSearch={onSearch} />
  );
};

export default PacksMenuHeader;
